module.exports = __webpack_public_path__ + "img/potencia_r_c_blue.5ec34a9d.svg";